/**
 * 深拷贝
 * @param {any} obj 拷贝对象
 * @param {WeekMap} hash hash对象
 */
export function deepClone(obj) {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (Array.isArray(obj)) {
    const clonedArr = [];
    for (let i = 0; i < obj.length; i++) {
      clonedArr[i] = deepClone(obj[i]);
    }
    return clonedArr;
  }

  const clonedObj = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      clonedObj[key] = deepClone(obj[key]);
    }
  }
  return clonedObj;
}

export function export_file(filePath) {
  window.open(`${window.config.url}${filePath}`);
}

/**
 *  处理下载接口需要拼接的数据，只传非null数据
 *
 * @param {object} data 需要发送的数据对象
 * @returns {string} 拼接的字符串
 */
export function noNullData(data) {
  let a = "";

  for (const k of Object.keys(data)) {
    const item = data[k];

    if (item) {
      a += `&${k}=${item}`;
    }
  }
  return a;
}

/*判断客户端*/
export function judgeClient() {
  let client = "";
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    //判断iPhone|iPad|iPod|iOS
    client = "iOS";
  } else if (/(Android)/i.test(navigator.userAgent)) {
    //判断Android
    client = "Android";
  } else {
    client = "PC";
  }
  return client;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js